import http from 'utils/http';

export const me = async () => {
  try {
    return http.get('/users/me');
  } catch (err) {
    throw err;
  }
};

export const getBanksData = async () => {
  try {
    const response = await http.get('/admin/banks/details');
    return response;
  } catch (err) {
    console.log('ERROR WHILE GETTING  BANKS DATA : ', JSON.stringify(err));
  }
};
const UserService = { me, getBanksData };

export default UserService;
